/* tslint:disable */
/* eslint-disable */

/**
 * Supported payment networks for the given tender type. A payment network is a card network like Visa, MasterCard, etc.
 */
export enum PaymentNetwork {
  All = 'All',
  AmericanExpress = 'AmericanExpress',
  Bancontact = 'Bancontact',
  BCcard = 'BCcard',
  Cabal = 'Cabal',
  Cirrus = 'Cirrus',
  DinersClub = 'DinersClub',
  Discover = 'Discover',
  Elo = 'Elo',
  Girocard = 'Girocard',
  Interac = 'Interac',
  Jcb = 'JCB',
  LienVietPostBank = 'LienVietPostBank',
  Maestro = 'Maestro',
  Mastercard = 'Mastercard',
  Naps = 'NAPS',
  PagSeguro = 'PagSeguro',
  PayPal = 'PayPal',
  Pulse = 'Pulse',
  RuPay = 'RuPay',
  Troy = 'Troy',
  UnionPay = 'UnionPay',
  Upi = 'UPI',
  Verve = 'Verve',
  Visa = 'Visa',
  Ziraat = 'Ziraat'
}
